import { render, staticRenderFns } from "./xmxqC.vue?vue&type=template&id=0dae7d54&scoped=true"
import script from "./xmxqC.vue?vue&type=script&lang=js"
export * from "./xmxqC.vue?vue&type=script&lang=js"
import style0 from "./xmxqC.vue?vue&type=style&index=0&id=0dae7d54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae7d54",
  null
  
)

export default component.exports